import React from 'react';
import { useTheme } from 'styled-components';
import { Breakpoint } from '../theme';

/*  This method will return null when server-side rendering, so when using this function,
    we should process the null and default to a sensible breakpoint for the component.  
    In general, we should try and choose the breakpoint with the most neutral styling, 
    as there will be a brief but non-trivial period when loading the page before the 
    correct breakpoint is loaded.
*/
export const useBreakpoint = (): Breakpoint | null => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint | null>(null);
  const theme = useTheme();

  React.useEffect(() => {
    const desktopQuery = window.matchMedia(
      `(min-width: ${theme.layout.desktop.breakpointMinPx}px)`
    );
    const tabletLandscapeQuery = window.matchMedia(
      `(min-width: ${theme.layout.tabletLandscape.breakpointMinPx}px)`
    );
    const tabletPortraitQuery = window.matchMedia(
      `(min-width: ${theme.layout.tabletPortrait.breakpointMinPx}px)`
    );

    const listener = (): void => {
      if (desktopQuery.matches) {
        setBreakpoint('desktop');
      } else if (tabletLandscapeQuery.matches) {
        setBreakpoint('tabletLandscape');
      } else if (tabletPortraitQuery.matches) {
        setBreakpoint('tabletPortrait');
      } else {
        setBreakpoint('mobile');
      }
    };

    tabletPortraitQuery.addListener(listener);
    tabletLandscapeQuery.addListener(listener);
    desktopQuery.addListener(listener);

    listener();
    return (): void => {
      desktopQuery.removeListener(listener);
      tabletLandscapeQuery.removeListener(listener);
      tabletPortraitQuery.removeListener(listener);
    };
  }, [theme]);

  return breakpoint;
};
